module.exports = __webpack_public_path__ + "img/tempura_teisyoku.29aabc2c.jpg";